export const checkboxes = [
  {
    name: 'usCitizenSsn',
    label: 'checkboxSsnLabel',
  },
  {
    name: 'taxesWithItin',
    label: 'checkboxItinLabel',
  },
  {
    name: 'livedInUs6Months',
    label: 'checkboxCitizenLabel',
  },
  {
    name: 'livedInCa6Months',
    label: 'checkboxCacitizenLabel',
  },
  {
    name: 'notDependent',
    label: 'claimLabel',
  },
  {
    name: 'noInvestmentIncomeOver11k',
    label: 'investmentLabel',
  },
  {
    name: 'hasChildUnder6',
    label: 'youngchildLabel',
  },
  {
    name: 'fosterCareAfter13',
    label: 'fosterCareLabel',
  },
  {
    name: 'spouseSsn',
    label: 'spouseSsnLabel',
  },
]
